import { render, staticRenderFns } from "./BranchProgress.vue?vue&type=template&id=2af00954&"
import script from "./BranchProgress.vue?vue&type=script&lang=js&"
export * from "./BranchProgress.vue?vue&type=script&lang=js&"
import style0 from "./BranchProgress.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports